<template>
<span v-if="sInformacion.length > 0" class="ma-0 pa-2">
  <v-menu
    v-model="showInfo"
    absolute
    offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-icon  medium color="gray darken-2" v-on="on" v-bind="attrs">mdi-information</v-icon>
    </template>
    <v-card class="ma-auto pa-0" max-width="200" >
      <v-card-text class="pa-0">
          <p  class="text--secondary">{{sInformacion}}</p>
      </v-card-text>
    </v-card>
  </v-menu>  
</span>
</template>

<script>

export default {
  name:"IconoInformacion",
  props: {
    sInformacion: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      showInfo: false
    }
  },
}
</script>

<style lang="scss" scoped>

</style>